import { BaseStatuses } from '@/constants/status-constants';
import { IntegrationStatusControls, IntegrationStatusControlsDto } from '@/integrations/models/integration-status-controls';

export interface StatusControlsViewModel {
    /** Whether to export children in wait list status */
    exportChildrenInWaitList: boolean;
    /** Status ID to set when a child has a future start date booking */
    futureStartDateStatus: number;
    /** Status ID to set when a child has an active/attending booking */
    activeBookingStatus: number;
    /** Status ID to set when a child's booking has ended */
    endedBookingStatus: number;
}

export class StatusControlsMapper {

    /**
     * Converts API response data to view model format for UI display.
     */
    toViewModel(apiResponse: IntegrationStatusControls): StatusControlsViewModel {
        return {
            exportChildrenInWaitList: apiResponse.start_export_from_wait_list,
            futureStartDateStatus: apiResponse.future_booking_status_transition.id,
            activeBookingStatus: apiResponse.active_booking_status_transition.id,
            endedBookingStatus: apiResponse.expired_booking_status_transition.id
        };
    }

    /**
     * Converts view model data to DTO format for API requests.
     */
    toDto(viewModel: StatusControlsViewModel): IntegrationStatusControlsDto {
        return {
            start_export_from_wait_list: viewModel.exportChildrenInWaitList,
            future_booking_status_transition: viewModel.futureStartDateStatus,
            active_booking_status_transition: viewModel.activeBookingStatus,
            expired_booking_status_transition: viewModel.endedBookingStatus
        };
    }

    /**
     * Creates a default view model with standard status control values.
     */
    toDefaultViewModel(): StatusControlsViewModel {
        return {
            exportChildrenInWaitList: false,
            futureStartDateStatus: BaseStatuses.REGISTERED,
            activeBookingStatus: BaseStatuses.ENROLLED,
            endedBookingStatus: BaseStatuses.WITHDRAWN
        };
    }
}
